// import { pdf } from '@react-pdf/renderer';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
// import SalesInvoicePDF from '../../components/StockReports/SalesInvoicePDF'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'cs/'

const initialState = {
    salesMaster: [],
    salesDetail: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getInvoiceByUser = createAsyncThunk('sc/gibu', async (userID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getInvoiceByUser', userID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addNewItem = createAsyncThunk('sc/ani', async (newItem, thunkAPI) => {
    try {
        return newItem
        // const result = await axios.post(API_URL + 'addNewItem', newItem)
        // return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteItem = createAsyncThunk('sc/di', async (RONO, thunkAPI) => {
    try {
        // console.log(RONO)
        // const result = await axios.post(API_URL + 'deleteItem', RONO)
        return RONO
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const masterSave = createAsyncThunk('sc/sm', async (_, thunkAPI) => {
    try {
        console.log('Master Save')
        const state = thunkAPI.getState().cs
        // const userState = thunkAPI.getState().auth
        const salesDetail = state.salesDetail
        console.log(salesDetail)
        const result = await axios.post(API_URL + 'masterSave', salesDetail)
        // console.log(result.data)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const masterSaveAfterChange = createAsyncThunk('sc/smac', async (changeData, thunkAPI) => {
    try {
        console.log(changeData)
        const result = await axios.post(API_URL + 'masterSaveAfterChange', changeData)
        // console.log(result.data)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const counterSalesSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.salesDetail = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }


    },
    extraReducers: (builder) => {
        builder
            .addCase(getInvoiceByUser.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getInvoiceByUser.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.salesMaster = action.payload
            })
            .addCase(getInvoiceByUser.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(addNewItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addNewItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                const existingItem = state.salesDetail.find(item => item.itemDesc === action.payload.itemDesc);

                if (existingItem) {
                    // If item exists, update the quantity
                    existingItem.itemQuantity += action.payload.itemQuantity;
                } else {
                    // If item does not exist, add the complete item details
                    state.salesDetail.push(action.payload);
                }
                // state.salesDetail.push(action.payload)
            })
            .addCase(addNewItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(deleteItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(deleteItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                console.log(action.payload)
                state.salesDetail = state.salesDetail.filter(item => item.barCode !== action.payload)
                state.message = action.payload
            })
            .addCase(deleteItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(masterSave.pending, (state) => {
                state.isLoading = true
            })
            .addCase(masterSave.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.salesMaster = action.payload
                state.salesDetail = []
                // const user = action.payload.user

                // const blob = await pdf(<SalesInvoicePDF salesMaster={state.salesMaster} user={user} />).toBlob();

                // // Trigger print dialog or save
                // const fileURL = URL.createObjectURL(blob);
                // const printWindow = window.open(fileURL);
                // printWindow.focus();
                // printWindow.print();
            })
            .addCase(masterSave.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = counterSalesSlice.actions

export default counterSalesSlice.reducer

